import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { DeleteIconButton } from '../../../../components/common/button/CustomIconButton';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
import CustomSelect from '../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';

interface IProps {
  moduleData: any;
  isView: boolean;
  handelDeleteRows: any;
}
const TBody = ({ moduleData, isView, handelDeleteRows }: IProps) => {
  const [render, setRender] = useState(false);

  return (
    <tbody>
      {moduleData.list &&
        moduleData.list.map((item: any, index: number) => (
          <tr key={`${index}_row`}>
            <td style={{ minWidth: '120px', width: '120px' }}>
              {formatDate(item.date)}
              {/* {isView ? (
                formatDate(item.date)
              ) : (
                <DatePickerMui
                  value={moment(item.date)}
                  onChange={(date) => {
                    item.date = date;
                    setRender((prev) => !prev);
                  }}
                />
              )} */}
            </td>
            <td style={{ minWidth: '160px', width: '160px' }}>
              {isView ? (
                formatDate(item.tool_unloading_date)
              ) : (
                <DatePickerMui
                  value={moment(item.tool_unloading_date)}
                  onChange={(date) => {
                    item.tool_unloading_date = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </td>
            <td style={{ minWidth: '160px', width: '160px' }}>
              <TableInput
                isView={true}
                name="machine_no"
                type="text"
                value={item.machine_no}
              />
            </td>
            <td style={{ minWidth: '160px', width: '160px' }}>
              <TableInput
                isView={true}
                name="actual_prod"
                type="number"
                value={item.actual_prod}
              />
            </td>
            <td style={{ minWidth: '160px', width: '160px' }}>
              <TableInput
                isView={true}
                name="comulative"
                type="text"
                value={item.comulative}
              />
            </td>
            <td
              // style={{
              //   ...(item.status === 'RED (R)' && { background: '#e03131' }),
              // }}
              style={{ minWidth: '160px', width: '160px' }}
            >
              {isView ? (
                item.status
              ) : (
                <CustomSelect
                  name="status"
                  value={item.status}
                  sx={{
                    background: `
                      ${
                        (item.status === 'GREEN (G)' && '#40c057') ||
                        (item.status === 'YELLOW (Y)' && '#ffe066') ||
                        (item.status === 'RED (R)' && '#e03131')
                      }
                    `,
                  }}
                  onChange={(e) => {
                    item.status = e.target.value;
                    setRender((prev) => !prev);
                  }}
                >
                  <MenuItem value="">NONE</MenuItem>
                  <MenuItem value="OK">OK</MenuItem>
                  <MenuItem value="NOT OK">NOT OK</MenuItem>
                  {/* <MenuItem value="RED (R)">RED (R)</MenuItem> */}
                </CustomSelect>
              )}
            </td>
            <td>
              <TableInput
                isView={isView}
                name="reason"
                type="text"
                value={item.reason}
                onChange={(e) => {
                  item.reason = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td colSpan={1}>
              <TableInput
                isView={isView}
                name="action_taken"
                type="text"
                value={item.action_taken}
                onChange={(e) => {
                  item.action_taken = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td>
              <TableInput
                isView={isView}
                name="updated_by"
                type="text"
                value={item.updated_by}
                onChange={(e) => {
                  item.updated_by = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td>
              <TableInput
                isView={isView}
                name="remarks"
                type="text"
                value={item.remarks}
                onChange={(e) => {
                  item.remarks = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
            </td>
            {/* {!isView && (
              <td style={{ width: '5px', textAlign: 'center' }}>
                <DeleteIconButton
                  tooltipTitle={'delete'}
                  onClick={() => handelDeleteRows(index)}
                />
              </td>
            )} */}
          </tr>
        ))}
    </tbody>
  );
};

export default TBody;
